import { Building2 } from "lucide-react";
import FinancePage from "@/components/FinancePage";

const CATEGORIES = ["Peralatan", "Server", "Perangkat Jaringan", "Kendaraan", "Properti", "Lainnya"];

const Assets = () => (
  <FinancePage
    title="Asset Usaha"
    subtitle="Daftar aset dan inventaris usaha Anda"
    endpoint="/assets"
    categories={CATEGORIES}
    icon={Building2}
    accent="primary"
    totalLabel="Total Nilai Asset"
  />
);

export default Assets;
